/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Category_ReviewInputs */



/**
* | output |
* | --- |
* | "Review" |
*
* @param {Qc_Category_ReviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_category_review = /** @type {((inputs?: Qc_Category_ReviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Category_ReviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Révision")
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Revisione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Revisión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("审阅")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समीक्षा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Revisão")
	return /** @type {LocalizedString} */ ("Review")
});